import React from 'react'

function AboutFive() {
    return (
        <div>
            {/* rts about area start */}
            <div className="rts-about-area-start rts-section-gapBottom">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 pr--70 pr_md--0 pr_sm--0">
                            <div className="title-area-style-six text-start">
                                <div className="pre-title">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/banner/shape/pre-title.png`}
                                        alt="pre-title"
                                    />
                                    <span className="pre">More ABOUT US</span>
                                    <img
                                        className="two"
                                        src={`${process.env.PUBLIC_URL}/assets/images/banner/shape/pre-title.png`}
                                        alt="pre-title"
                                    />
                                </div>
                                <h2 className="title">
                                    Here is your perfect <br />
                                    Marketing Solution
                                </h2>
                            </div>
                            <div className="about-content-inner-style-six">
                                <p className="disc">
                                    Platea vehicula rutrum curae magna tacitiacut msuada inceptos
                                    phasellus massa, eget ultres tempor lacinia dictumst tincidunt leo
                                    mollis luctus varius gravida eleifend cursus litora
                                </p>
                                <div className="item-check-inner">
                                    <div className="single-col">
                                        <div className="single-check">
                                            <i className="fas fa-check-circle" />
                                            24/7 Call Services Avilable
                                        </div>
                                        <div className="single-check">
                                            <i className="fas fa-check-circle" />
                                            Great Skilled Consultant
                                        </div>
                                        <div className="single-check">
                                            <i className="fas fa-check-circle" />
                                            Expert Team Members
                                        </div>
                                    </div>
                                    <div className="single-col">
                                        <div className="single-check">
                                            <i className="fas fa-check-circle" />
                                            How to improve business
                                        </div>
                                        <div className="single-check">
                                            <i className="fas fa-check-circle" />
                                            Business is the best plan
                                        </div>
                                        <div className="single-check">
                                            <i className="fas fa-check-circle" />
                                            Services we provide
                                        </div>
                                    </div>
                                </div>
                                <div className="contact-inner-about">
                                    <div className="single-left">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/about/main/user/04.png`} alt="user" />
                                        <div className="details-area">
                                            <h6 className="title">Adrew David</h6>
                                            <span className="designation">CEO &amp; Founder</span>
                                        </div>
                                    </div>
                                    <div className="single-right">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/about/main/user/05.png`} alt="call" />
                                        <div className="details-area">
                                            <span>Call us anytime</span>
                                            <a href="#" className="number">
                                                +256 214582146
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="thumbnail-about-six">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/about/02.png`} alt="about-image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* rts about area end */}
        </div>
    )
}

export default AboutFive